var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleDarkMode}},[(_vm.$store.state.settings.darkMode)?_c('v-icon',[_vm._v("mdi-white-balance-sunny")]):_c('v-icon',[_vm._v("mdi-weather-night")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }